import React, { useEffect } from "react";
import MatchListing from "./common/liveCenter/matchListing/MatchListing";
import { ColorVariables } from "../utils/general";

// New wrapper components

import IceHockeyMatchWidgetWrap from "./widgetBoxes/ice-hockey/IceHockeyMatchWidgetWrap";
import IceHockeyLeagueWidgetWrap from "./widgetBoxes/ice-hockey/IceHockeyLeagueWidgetWrap";
import IceHockeyTeamWidgetWrap from "./widgetBoxes/ice-hockey/IceHockeyTeamWidgetWrap";


const IceHockeyWidgets = ({
    dataId,
    dataType,
    sport,
    difference,
    head,
    data,
    headData,
    baseUrl,
    loadCSS,
    setDataId,
    setDataType,
    setHead,
    setDate,
    date,
    setIsLive,
    isLive,
    dataClient = false,
    websiteBaseUrl,
    dataPath,
    dataTitle,
}) => {
    useEffect(() => {
        const loadSettings = async () => {
            try {
                const res = await fetch(`${baseUrl}/settings`, {
                    headers: {
                        Token: process.env.REACT_APP_SETTINGS_TOKEN,
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                });

                if (!res.ok) throw new Error(res.statusText);

                const settings = await res.json();
                const cssVars = ColorVariables(settings);

                const styleTag = document.createElement("style");
                styleTag.textContent = cssVars;
                document.head.appendChild(styleTag);

                document.querySelectorAll(".microservice-cont")?.forEach((el) => el?.classList.add("hydrated"));


                return () => {
                    if (document.head.contains(styleTag)) {
                        document.head.removeChild(styleTag);
                    }
                };
            } catch (err) {
                console.error("Failed to load settings:", err);
            }
        };

        loadSettings();
    }, [baseUrl]);

    const commonProps = {
        dataId,
        dataType,
        sport,
        difference,
        head,
        data,
        headData,
        baseUrl,
        loadCSS,
        setDataId,
        setDataType,
        setHead,
        setDate,
        date,
        setIsLive,
        isLive,
        dataClient,
        websiteBaseUrl,
        dataPath,
        dataTitle,
    };

    if (dataType === "live-match-detail" || dataType === "live-centre") {
        return <MatchListing {...commonProps} data={data?.data} matchType="all" />;
    }

    if (dataType?.startsWith("icehockey-match")) {
        return <IceHockeyMatchWidgetWrap {...commonProps} />;
    }

    if (dataType?.startsWith("icehockey-league-")) {
        return <IceHockeyLeagueWidgetWrap {...commonProps} />;
    }

    if (dataType?.startsWith("icehockey-team-")) {
        return <IceHockeyTeamWidgetWrap {...commonProps} />;
    }

    return <h1>Widget Not Found in Ice Hockey !</h1>;
};

export default IceHockeyWidgets;
